const eventCategories = ['LandViewerEvents', 'VisionEvents', 'AuthEvents', 'AgroDesktop', 'StorageEvents', 'All'];

export default eventCategories;
